/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Link as RouterLink } from 'react-router';

import { useLocation, useParams } from 'js/lib/useRouter';

import { Button } from '@coursera/cds-core';

import CourseraLogo from 'bundles/page/components/CourseraLogo';

import _t from 'i18n!nls/enterprise-admin-ai-program-builder';

const bannerStyles = css`
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--cds-color-white-0);
  border: 1px solid var(--cds-color-neutral-stroke-primary-weak);
  padding: 4px 12px 4px 20px;
`;

export const BuilderHeader = () => {
  const { thirdPartySlug, programDraftSlug } = useParams();
  const location = useLocation();
  const existingProgram = location.pathname.includes('/existing-program');
  return (
    <header css={bannerStyles} role="banner">
      <RouterLink
        to={`/o/${thirdPartySlug}/admin/home`}
        css={css`
          display: flex;
        `}
      >
        <CourseraLogo
          css={css`
            height: 16px;
          `}
        />
      </RouterLink>
      <Button
        variant="ghost"
        component={RouterLink}
        to={
          existingProgram
            ? `/o/${thirdPartySlug}/admin/programs/${programDraftSlug}/curriculum`
            : `/o/${thirdPartySlug}/admin/home`
        }
      >
        {_t('Close')}
      </Button>
    </header>
  );
};
